// /src/components/donate/donatePanelCostIcons.jsx

import React from 'react';

function IconShell({ children, className = '' }) {
  return (
    <span className={`donate-panel-member__icon ${className}`.trim()} aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        {children}
      </svg>
    </span>
  );
}

export function DonateCostGlobeIcon() {
  return (
    <IconShell>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M3 12h18M12 3c2.8 3.1 2.8 14.9 0 18M12 3c-2.8 3.1-2.8 14.9 0 18" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </IconShell>
  );
}

export function DonateCostServerIcon() {
  return (
    <IconShell>
      <rect x="4" y="4" width="16" height="6" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="4" y="14" width="16" height="6" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="8" cy="7" r="0.9" fill="currentColor" />
      <circle cx="8" cy="17" r="0.9" fill="currentColor" />
    </IconShell>
  );
}

export function DonateCostCloudIcon() {
  return (
    <IconShell>
      <path
        d="M7 18h10a4 4 0 0 0 .4-8 5.5 5.5 0 0 0-10.6 1.2A3.5 3.5 0 0 0 7 18z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </IconShell>
  );
}

export function DonateCostCodeIcon() {
  return (
    <IconShell>
      <path d="M9 8L4 12l5 4M15 8l5 4-5 4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </IconShell>
  );
}

export function DonateCostDefaultIcon() {
  return (
    <IconShell>
      <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </IconShell>
  );
}

export function DonateCostHexTotalIcon() {
  return (
    <span className="donate-panel-member__total-hex" aria-hidden="true">
      <svg viewBox="0 0 48 48" focusable="false">
        <path
          d="M24 4 L41 14 L41 34 L24 44 L7 34 L7 14 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path d="M16 28h16M16 22h10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </span>
  );
}

export function DonateCostStarIcon() {
  return (
    <span className="donate-panel-member__footer-star" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path
          d="M12 4.5l2.2 4.8 5.3.5-4 3.5 1.2 5.2L12 16.2 7.3 18.5l1.2-5.2-4-3.5 5.3-.5L12 4.5z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export function resolveCostRowIcon(category) {
  const value = String(category || '').trim().toLowerCase();
  if (!value) return DonateCostDefaultIcon;
  if (value.includes('domain') || value.includes('cdn')) return DonateCostGlobeIcon;
  if (value.includes('vps') || value.includes('server') || value.includes('infrastructure')) return DonateCostServerIcon;
  if (value.includes('host') || value.includes('static') || value.includes('cloud')) return DonateCostCloudIcon;
  if (value.includes('dev') || value.includes('tool') || value.includes('chatgpt') || value.includes('cursor')) {
    return DonateCostCodeIcon;
  }
  return DonateCostDefaultIcon;
}
